<template>
    <component
            :is="selectedLayout"
            v-if="renderData.titleId"
            v-bind="renderData"
            @payment-option-selected="paymentOptionSelected"
            @enroll-clicked=""
    ></component>

    <div class="learnworlds-align-center" v-else>
        <p class="learnworlds-main-text learnworlds-main-text-normal learnworlds-element p-20-0">
            No results
        </p>
    </div>
</template>
<script>
    import PaymentOptionsComponent from "../../components/pagesbuilder/dynamic-components/PaymentOptionsComponent";
    import PreviewComponent from "./PreviewComponent";

    export default {
        name: "PreviewPaymentOptionsComponent",
        mixins: [PreviewComponent, PaymentOptionsComponent],
        data () {
            return {
                optionsUseHref: true
            }
        },
    }
</script>
